import {
  SPACER,
  DESCRIPTION,
  STREET_ADDRESS,
  CITY,
  POSTAL_CODE,
  DESCRIPTION_TITLE,
  ADDRESS_INFORMATION_TITLE,
  SERVICES_TITLE,
  VANTAGE_POINT_SERVICES
} from '../elements.template'

const LAYOUT = {
  type: 'subentity_vantage_point',
  layout: [
    [
      // Start left column
      SERVICES_TITLE,
      VANTAGE_POINT_SERVICES,
      DESCRIPTION_TITLE,
      DESCRIPTION,
      ADDRESS_INFORMATION_TITLE,
      {
        type: 'container',
        className: 'customRowFixed',
        items: [
          STREET_ADDRESS,
          SPACER,
          CITY,
          SPACER,
          POSTAL_CODE
        ]
      }
      // End left column
    ],
    [
      // Start of right column
      // End of right column
    ]
  ]
}

export default LAYOUT
